import { element } from 'prop-types';
import { data } from './content'
import { LANG } from './LangConfig'

export const scrollToAnchor = (id) => {
    const elmnt = document.getElementById(id);
    elmnt.scrollIntoView({ behavior: "smooth" });

    // const yOffset = -10; 
    // const element = document.getElementById(id);
    // const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    // window.scrollTo({top: y, behavior: 'smooth'});
};

const form = data[LANG].form;
const formLang = LANG;

export const pageDomain = process.env.REACT_APP_DOMAIN ? process.env.REACT_APP_DOMAIN : window.location.host
// export const sideMenu = new window.LotterySideMenu(form.get_started, form.subtitle, formLang,
//     function (data, link, loginnow) {
//         localStorage.setItem("lottery_token", data.data.token);
//         localStorage.setItem("url", loginnow);
//         window.location.reload()
//     });

export const sideMenu = new window.SideForm.PromoSpinAndWin({
    documentID: 'app-side',
    lang: formLang,
    countryCode: 'au',
    setting: {
        title: form.get_started,
        subtitle: form.subtitle,
        bottomText: form.bottom_text
    },
    pageDomain: () => (pageDomain),
    callback: (token, cloudhubOption) => {
        localStorage.setItem("lottery_token", token)
        localStorage.setItem("url", cloudhubOption)

        window.location.reload()
        document.getElementById('spin-wheel').scrollIntoView()
    }
})


export const handleAccount = (lang = 'en') => {
    let baseUrl = 'https://www.acy.cloud';
    const pageUrl = window.location.href
    let queryString = '';
    if (window && window.location.search) {
        queryString = `${window.location.search}&url=${pageUrl}&next=/create-account/select-account-type&locale=${lang}`;
    } else {
        queryString = `?url=${pageUrl}&next=/create-account/select-account-type&locale=${lang}`;
    } 
    if(process.env.REACT_APP_DOMAIN === 'acycn.com'){
        baseUrl = 'https://acycn.cloud'
    }
    return () => window.open(`${baseUrl}/open-live-account${queryString}`, '_blank');
}